import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import bubble from "../Assests/bubble.jpeg";

const popupVariants = {
  hidden: { opacity: 0, scale: 0.6, x: 80, y: 80 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 18,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.6,
    x: 80,
    y: 80,
    transition: { duration: 0.4 },
  },
};

const AutoPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);

    const timer = setTimeout(() => {
      setOpen(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {open && (
<motion.div
  variants={popupVariants}
  initial="hidden"
  animate="visible"
  exit="exit"
  className="
    fixed bottom-8 right-8 z-50
    w-64 h-64 md:w-72 md:h-72
    rounded-3xl shadow-2xl border border-orange-400
    bg-white overflow-hidden
    backdrop-blur-xl
  "
  style={{
    boxShadow:
      "0 10px 30px rgba(255, 140, 0, 0.35), 0 0 25px rgba(255, 90, 0, 0.3)",
  }}
>
  {/* ✖ Close Button */}
  <button
    onClick={() => setOpen(false)}
    className="
      absolute top-2 right-2 z-50
      bg-white/80 backdrop-blur-md
      w-10 h-15 flex items-center justify-center
      rounded-full shadow-md border border-gray-300
      hover:bg-red-500 hover:text-white transition
    "
  >
    ✕
  </button>

  {/* breathing animation for image */}
  <motion.img
    src={bubble}
    alt="Popup"
    className="w-full h-full object-cover"
    initial={{ scale: 1.1 }}
    animate={{
      scale: [1, 1.05, 1],
    }}
    transition={{
      duration: 2.2,
      repeat: Infinity,
      ease: "easeInOut",
    }}
  />
</motion.div>

      )}
    </AnimatePresence>
  );
};

export default AutoPopup;
